import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CloseIcon from "@mui/icons-material/Close";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import SvgIcon from "@mui/material/SvgIcon";
import Tooltip from "@mui/material/Tooltip";
import { useContext, useState } from "react";
import { InfoCircle } from "react-bootstrap-icons";
import "../../../../Tooltip/styles/tooltip.css";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider";
import { FormContext } from "../context/FormProvider";
import * as Messages from "../messages/messages";
import "../styles/form-container.css";
import "./styles/radio-group-field.css";

// RadioGroupField component is used to render a radio group in the form (Yes/No)
const RadioGroupField = ({
  label,
  idProp,
  state,
  setState,
  debouncedSave,
  setIsLoading,
  disabledInput,
}) => {
  const [open, setOpen] = useState(false);
  const { slide5, handleInputDisable } = useContext(FormContext);

  const { userId } = useContext(DashboardContext);

  const resetFields = {
    isLinear: {
      eLat: "",
      eLng: "",
    },
    swpppServicesRequest: {
      noiRequest: false,
      noiFilingDate: "",
      notPreparationRequest: false,
      lvvChecklistRequest: false,
      swpppPreparationRequest: false,
      swpppInspectionRequest: false,
      postingNoticeSignRequest: false,
      bmpInstallationRequest: false,
      bmpMaintenanceRequest: false,
    },
    safetyInterest: {
      level1Safety: "",
      level2Safety: "",
    },
    airQualityServicesRequest: {
      filePermitRequest: false,
      amendPermitRequest: false,
      dustSignRequest: false,
      dustMonitoringRequest: false,
      wateringServiceRequest: false,
    },
  };

  // Function to handle the radio group change
  const handleCheckboxChange = (e) => {
    let newState = { ...state };
    let realID = e.target.id.split("-")[0];
    const clickedValue = e.target.value;
    const currentValue = state[realID];

    let updatedValue;

    if (clickedValue === currentValue) {
      updatedValue = "";
    } else {
      updatedValue = clickedValue;
    }

    newState[realID] = updatedValue;

    if (updatedValue === "No") {
      if (realID === "sameAsOwner") {
        setState({
          ...newState,
          gcName: "",
          gcAdd: "",
          gcCity: "",
          gcState: "",
          gcZip: "",
          gcPhone: "",
          gcFax: "",
          gcTaxId: "",
          gcContactName: "",
          gcContactPhone: "",
          gcContactEmail: "",
          gcContactTitle: "",
          gcAuthorizedContactName: "",
          gcAuthorizedContactTitle: "",
        });
      } else if (resetFields[realID]) {
        newState = { ...newState, ...resetFields[realID] };
      }
    }

    if (updatedValue === "Yes" && realID === "sameAsOwner") {
      newState = {
        ...newState,
        sameAsOwner: "Yes",
        gcName: slide5.oName,
        gcAdd: slide5.oAdd,
        gcCity: slide5.oCity,
        gcState: slide5.oState,
        gcZip: slide5.oZip,
        gcPhone: slide5.oPhone,
        gcFax: slide5.oFax,
        gcTaxId: slide5.oTaxId,
        gcContactName: slide5.oContactName,
        gcContactPhone: slide5.oContactPhone,
        gcContactEmail: slide5.oContactEmail,
        gcContactTitle: slide5.oContactTitle,
        gcAuthorizedContactName: slide5.oAuthorizedContactName,
        gcAuthorizedContactTitle: slide5.oAuthorizedContactTitle,
      };
      setState(newState);
    }

    if (updatedValue === "Yes" && realID === "level1Safety") {
      newState = {
        ...newState,
        safetyInterest: "Yes",
        level2Safety: "No",
      };
      setState(newState);
    } else if (updatedValue === "Yes" && realID === "level2Safety") {
      newState = {
        ...newState,
        safetyInterest: "Yes",
        level1Safety: "No",
      };
      setState(newState);
    } else {
      setState(newState);
    }
    if (debouncedSave && setIsLoading) {
      setIsLoading(true);
      debouncedSave.mutate(newState);
    }
  };

  return (
    <>
      <div
        className="input-radio-group-container"
        id={`${idProp}-radio-container`}
      >
        <label
          id={`${idProp}-label`}
          className="radio-group-form-label"
          htmlFor={`radio-${idProp}`}
        >
          {label}:
        </label>
        <div
          className="input-info-radio-group-container"
          id={`${idProp}-info-container`}
        >
          <FormGroup
            row={true}
            className="radio-grouping"
            aria-label={`${label} radio-group`}
            name={`radio-${idProp}`}
            id={`radio-${idProp}`}
            value={state[idProp]}
            onChange={handleCheckboxChange}
            classes={{
              row: "radio-group-row",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  id={`${idProp}-true`}
                  value={"Yes"}
                  checked={state[idProp] === "Yes"}
                  disabled={handleInputDisable(
                    idProp,
                    state,
                    disabledInput,
                    userId,
                  )}
                  classes={{
                    root: "radio-group-btn-true",
                    checked: "radio-group-btn-checked",
                  }}
                  icon={
                    <SvgIcon
                      component={CheckBoxOutlineBlankIcon}
                      className="radio-group-btn-icon-true"
                      viewBox="3.6 3.6 16.8 16.8"
                    />
                  }
                  checkedIcon={
                    <SvgIcon
                      component={CheckBoxIcon}
                      className="radio-group-btn-icon-true"
                      viewBox="3.6 3.6 16.8 16.8"
                    />
                  }
                />
              }
              label="Yes"
              id={`true-label-group`}
              classes={{
                label: "radio-group-btn-label",
                root: "radio-group-form-control-label",
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  id={`${idProp}-false`}
                  value={"No"}
                  checked={state[idProp] === "No"}
                  disabled={handleInputDisable(
                    idProp,
                    state,
                    disabledInput,
                    userId,
                  )}
                  classes={{
                    root: "radio-group-btn-false",
                    checked: "radio-group-btn-checked",
                  }}
                  icon={
                    <SvgIcon
                      component={CheckBoxOutlineBlankIcon}
                      className="radio-group-btn-icon-false"
                      viewBox="3 3 18 18"
                    />
                  }
                  checkedIcon={
                    <SvgIcon
                      component={CloseIcon}
                      className="radio-group-btn-icon-false"
                      viewBox="2 2 20 20"
                    />
                  }
                />
              }
              label="No"
              id={`false-label-group`}
              classes={{
                label: "radio-group-btn-label",
                root: "radio-group-form-control-label",
              }}
            />
          </FormGroup>
          <Tooltip
            id="rg-tooltip"
            classes={{
              tooltip: "radio-group-tooltip",
              popper: "radio-group-popper",
              arrow: "radio-group-arrow",
              tooltipPlacementRight: "radio-group-right",
            }}
            title={Messages[`${idProp}Message`] || ""}
            open={open}
            arrow
            placement="right"
          >
            <InfoCircle
              className="text-info-circ"
              id={`info-${idProp}`}
              color="white"
              size={30}
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}
            />
          </Tooltip>
        </div>
      </div>
    </>
  );
};

export default RadioGroupField;
